import { Page } from "@/components/page";
import { Text, Title, Stack, Space, List, Anchor } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/payment-processor-policy")({
  component: PaymentProcessorPolicyRouteComponent,
});

function PaymentProcessorPolicyRouteComponent() {
  return (
    <Page title="Payment Processor Policy">
      <Space h="2rem" />
      <Stack gap="1rem" maw="800" mx="auto" p="lg">
        <Title size="2.5rem">Payment Processing Policy</Title>
        <Text>
          All payments, refunds, and cancellations for this website are securely
          processed and managed by{" "}
          <b>
            <a href="https://scrolller.com">Scrolller</a>
          </b>
          .
        </Text>
        <Text>
          By making a purchase through our website, you acknowledge and agree
          that:
        </Text>
        <List>
          <List.Item>
            <b>Scrolller</b> is our authorized payment processor.
          </List.Item>
          <List.Item>
            <b>Scrolller</b> handles all payment transactions, including
            billing, refunds, and cancellations.
          </List.Item>
          <List.Item>
            Any inquiries regarding payments, including refund requests or
            transaction issues, should be directed to <b>Scrolller</b> support
            at{" "}
            <Anchor inherit href="mailto:support@fapinstructor.com">
              support@fapinstructor.com
            </Anchor>
            .
          </List.Item>
        </List>
      </Stack>
      <Space h="xl" />
    </Page>
  );
}
